/**
 * The terms and the privacy policy, as baked in at build time.
 *
 * There is no in-repo fallback on purpose. Everything else on the marketing
 * site has one, because a missing headline should not take a page down — but a
 * legal document is not decoration, and showing a stale copy of a contract that
 * has since changed is worse than showing none. If the CMS has no published
 * document, the page says so and points at the contact address.
 */
import { CMS_LEGAL } from './_generated/cms-legal';

export type LegalKind = 'terms' | 'privacy';

export interface LegalDocument {
  kind: string;
  title: string;
  /** Sanitized HTML, produced by the CMS. */
  body: string;
  version: string;
  effective_from: string | null;
  /**
   * The language actually served — not necessarily the one asked for. The API
   * hands back the source document whole when a locale has not been translated,
   * so the page can tell the reader rather than let them assume.
   */
  language: string;
  updated: string;
}

export function getLegalDocument(lang: string, kind: LegalKind): LegalDocument | null {
  const byKind = (CMS_LEGAL as Record<string, Record<string, LegalDocument>>)[lang];
  return byKind?.[kind] ?? null;
}
